module.exports = __webpack_public_path__ + "img/news-one-img-1.0bd6494d.jpg";